import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-10 py-16">
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-signal">About</span>
      <h1 className="font-anton text-5xl md:text-7xl uppercase tracking-tight mt-3 leading-none" data-testid="about-title">
        Nero Sun
      </h1>

      <div className="space-y-6 mt-10 text-foreground/85 text-lg leading-relaxed">
        <p>
          NERO SUN is a digital magazine charting the global convergence of hip-hop and everything
          it touches — music, athletes, fashion, shoes, cars, travel, technology, business, media and food — from an urban
          perspective. We cover the point where culture, commerce and craft collide.
        </p>
        <p>
          We tell the stories of the people moving the culture forward, and we rank them. Our{" "}
          <Link to="/rankings" className="text-signal hover:underline">Power Index</Link> scores the
          artists shaping the world across six pillars — fashion, cars, business, style, real estate
          and technology — and is refreshed regularly to keep the movement honest.
        </p>
        <p>
          Beyond editorial, NERO SUN partners with brands through culture-first advertorials and
          premium placements. If you want to reach our audience, visit our{" "}
          <Link to="/advertise" className="text-signal hover:underline">Advertise</Link> page.
        </p>

        <h2 className="font-anton text-2xl uppercase tracking-tight pt-6">Our Editorial Standard</h2>
        <p>
          Every feature is written to magazine quality with attitude and authority. Some stories are
          crafted with the help of AI tools and reviewed before publication. Sponsored content is
          always clearly labeled as a Paid Partnership.
        </p>

        <h2 className="font-anton text-2xl uppercase tracking-tight pt-6">Contact</h2>
        <p>
          Questions, tips, or partnerships? Reach us via the{" "}
          <Link to="/contact" className="text-signal hover:underline">Contact</Link> page or email{" "}
          <a href="mailto:peartmedia@gmail.com" className="text-signal hover:underline">peartmedia@gmail.com</a>.
        </p>
      </div>
    </div>
  );
}
